import React, {useEffect, useState} from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Modal,
    Form,
    Spinner,
} from "react-bootstrap";
import {DriveFolderUpload} from "@mui/icons-material";
import Images from "../../constants/Images";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import LoginIcon from "@mui/icons-material/Login";
import {useNavigate} from "react-router-dom";
import {apiRequest} from "../../services";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-free/css/all.css";
import {useDispatch, useSelector} from "react-redux";
import "./home.css";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const Hme = () => {
    const {t} = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(null);
    const appUser = "webtechcare";
    const appPassword = "kP9!vR2$mZ6#tQ1";
    const [formData, setFormData] = useState({
        password: "",
        userNameOrEmail: "",
    });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [viewpassword, setViewPassword] = useState(false);
    const [activeIndex] = useState(1);
    const [navigateTo, setNavigateTo] = useState("");
    const [formError, setFormError] = useState({
        userNameOrEmail: null,
        password: null,
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.users);
    //const [token, setToken] = useState(null);
    const [loginResponse, setLoginResponse] = useState(null); // Store login response

    const TogglePassword = (event) => {
        event.preventDefault();
        setViewPassword(!viewpassword);
    };

    const handleToggleLoginModal = (route) => {
        if (userData?.users?.userName) {
            setNavigateTo(route);
            navigate(route);
        } else {
            setShowModal(!showModal);
            setNavigateTo(route);
        }
    };

    const handleNavigate = (route) => {
        setNavigateTo(route);
        navigate(route);
    };

    const validateForm = (fieldName, currentFormData) => {
        const errors = {...formError};
        switch (fieldName) {
            case "userNameOrEmail":
                if (!currentFormData.userNameOrEmail) {
                    errors.userNameOrEmail = t("requiredField");
                } else {
                    delete errors.userNameOrEmail;
                }
                break;
            case "password":
                if (!currentFormData.password) {
                    errors.password = t("requiredField");
                } else if (currentFormData.password.length !== 5) {
                    errors.password = t("votre mot de passe doit avoir 5 chiffres");
                } else {
                    delete errors.password;
                }
                break;
            default:
                break;
        }
        setFormError(errors);
    };

    const handleToggleLoginModalSubscription = (route) => {
        setNavigateTo(route);
        navigate(route);
    };

    const hideAddLoginModal = () => {
        setShowModal(false);
        setShowOTPModal(false);
        setSuccessMessage("");
        setErrorMessage("");
        setOtp("");
        setOtpError(null);
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        validateForm(name, {...formData, [name]: value});
    };

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
        if (e.target.value) {
            setOtpError(null);
        }
    };

    const handleAppLogin = async () => {

        const loginApp = {
            userNameOrEmail: appUser,
            password: appPassword,
        };

        await apiRequest(
            "LOGIN",
            "TechCareAuthentification/login",
            "POST",
            loginApp,
            null,
            dispatch,
            navigate
        ).then(async (res) => {
            if (res && res.status === 200) {
                dispatch({
                    type: 'LOGIN_APP',
                    token: res.body.data.token,
                    expiration: res.body.data.expiration
                })
                console.log('App Login Response', res)
            }
        }).catch((error) => {
            console.error(error);
            toast.error(t("loginError"));
        });
    }


    const token = useSelector((state) => {
        return state.users.token
    });


    useEffect(() => {
        console.log("mon token ===", token)
        console.log("mon effect ===", !token)
        // if(!token){
            handleAppLogin()
        // }
    }, [token]);


    const fetchClientDetails = async (userName) => {
        try {
            const requestData = {
                serviceReference: "GET_CLIENT_BY_INSURANCE_CODE",
                requestBody: userName,
            };
            const response = await apiRequest(
                "GATEWAY",
                "",
                "POST",
                requestData,
                token,
                dispatch,
                navigate
            );
            console.log("responsesssssssssss ", response);
            if (response && response.status === 200) {
                dispatch({
                    type: "SET_CLIENT_DETAILS",
                    value: response.body.data,
                });
                return true;
            } else {
                toast.error(t("failedToFetchClientDetails"));
                return false;
            }
        } catch (error) {
            console.error("Error fetching client details:", error);
            toast.error(t("errorFetchingClientDetails"));
            return false;
        }
    };

    const requestOtp = async (userNameOrEmail) => {
        try {
            const response = await apiRequest(
                "LOGIN",
                `/TechCareAuthentification/processToGenerateOtpCode/${userNameOrEmail}`,
                "POST",
                null,
                token,
                dispatch,
                navigate
            );
            if (response && response.status === 200) {
                return true;
            } else {
                toast.error(t("failedToRequestOtp"));
                return false;
            }
        } catch (error) {
            console.error("Error requesting OTP:", error);
            toast.error(t("errorRequestingOtp"));
            return false;
        }
    };

    const verifyOtp = async (userNameOrEmail, otpCode) => {
        try {
            const response = await apiRequest(
                "LOGIN",
                `/TechCareAuthentification/verifiedOtp/${userNameOrEmail}/${otpCode}`,
                "POST",
                null,
                null,
                dispatch,
                navigate
            );
            console.log("response ", response);
            if (response && response.status === 200) {
                return true;
            } else {
                toast.error(t("invalidOtp"));
                return false;
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            toast.error(t("errorVerifyingOtp"));
            return false;
        }
    };

    const handleLogin = async () => {
        validateForm("userNameOrEmail", formData);
        validateForm("password", formData);

        if (Object.keys(formError).length > 0) {
            toast.error(t("formInvalid"));
            return;
        }

        setLoading(true);
        try {

            const loginData = {
                serviceReference: "VERIFY_CLIENT_PIN_CODE",
                requestBody: JSON.stringify({
                    msisdn: formData.userNameOrEmail,
                    pinCode: formData.password,
                })
            }

            const responseLogin = await apiRequest(
                "LOGIN",
                "techCareApiService/request",
                "POST",
                loginData,
                token,
                dispatch,
                navigate
            )
            if (responseLogin && responseLogin.status === 200 && responseLogin?.body?.data === true) {
                console.log("response login is ", responseLogin);
                setLoginResponse(responseLogin)
                console.log("tokeennnnnnnnn is ", token);
                const otpRequested = await requestOtp(formData.userNameOrEmail);
                if (otpRequested) {
                    setShowModal(false);
                    setShowOTPModal(true);
                } else {
                    toast.error(t("failedToRequestOtp"));
                }
            } else {
                // toast.error(t(responseLogin.body.errors));
                toast.error(t("incorrectCredentials"));
            }
        } catch (error) {
            console.error(error);
            toast.error(t("loginError"));
        }
        setLoading(false);
    };




    const handleOtpSubmit = async () => {
        if (!otp) {
            setOtpError(t("requiredField"));
            return;
        }
        setLoading(true);
        try {
            const otpVerified = await verifyOtp(formData.userNameOrEmail, otp);
            if (otpVerified) {
                if (loginResponse) {
                    dispatch({
                        type: "USER",
                        value: loginResponse.body.data,
                    });
                }
                await fetchClientDetails(formData.userNameOrEmail);
                navigate(navigateTo);
                hideAddLoginModal();
            } else {
                setOtpError(t("invalidOtp"));
            }
        } catch (error) {
            console.error(error);
            toast.error(t("errorVerifyingOtp"));
        }
        setLoading(false);
    };




    return (
        <div>
            <div className="hero_area">
                <header className="header_section">
                    <div className="header_top">
                        <div className="container-fluid">
                            <div className="contact_nav">
                                <a href="#supportPhone">
                                    <i className="fa fa-phone me-2" aria-hidden="true"></i>
                                    <span>Call : +237681480507</span>
                                </a>
                                <a href="#supportEmail">
                                    <i className="fa fa-envelope me-2" aria-hidden="true"></i>
                                    <span>Email : helpdesk@credixcm.com</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="header_bottom">
                        <div className="container-fluid"></div>
                    </div>
                </header>
                <section className="slider_section">
                    <Container>
                        <Row>
                            <Col md={6}>
                                <div className="detail-box">
                                    <h1 style={{color: "#fff"}}>
                                        TechCare 237
                                        <br/>
                                    </h1>
                                    <h3 style={{color: "#fff"}}>
                                        {t("techcare_subtitle")}
                                        <br/>
                                    </h3>
                                    <div>
                                        <p style={{color: "#ffff", fontSize: "18px"}}>
                                            {t("collaboration_text")}
                                        </p>
                                    </div>
                                    <div
                                        className="logo-frame-home"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <img
                                            src={Images.CredixLogo}
                                            style={{width: "18%", height: "18%"}}
                                            alt="Credix Logo"
                                            className="no-hover-effect"
                                        />
                                        <img
                                            src={Images.SanlamLogo}
                                            alt="sanlam-logo"
                                            style={{width: "55%", height: "55%"}}
                                            className="no-hover-effect p-2"
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div
                                    className="img-box"
                                    style={{marginTop: "-100px", transform: "scale(1.1)"}}
                                >
                                    <img
                                        src={Images.Image6}
                                        alt="imageInsurance"
                                        className="no-hover-effect"
                                        style={{width: "100%", height: "auto"}}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
            <section className="feature_section" style={{marginTop: "75px"}}>
                <div className="container">
                    <div className="feature_container">
                        <div
                            className={`box ${activeIndex === 2 ? "active" : ""}`}
                            onClick={() => handleToggleLoginModal("/profiles")}
                        >
                            <div className="img-box">
                                <LoginIcon/>
                            </div>
                            <h5 className="name">{t("connexion")}</h5>
                        </div>
                        <div
                            className={`box ${activeIndex === 2 ? "active" : ""}`}
                            onClick={() => handleNavigate("/declaration")}
                        >
                            <div className="img-box">
                                <DriveFolderUpload/>
                            </div>
                            <h5 className="name">{t("declaration")}</h5>
                        </div>
                        <div
                            className={`box ${activeIndex === 2 ? "active" : ""}`}
                            onClick={() => handleNavigate("/nosProduits")}
                        >
                            <div className="img-box">
                                <HealthAndSafetyIcon/>
                            </div>
                            <h5 className="name">{t("epargnes")}</h5>
                        </div>
                        <div
                            className={`box ${activeIndex === 2 ? "active" : ""}`}
                            onClick={() => handleToggleLoginModalSubscription("/tec")}
                        >
                            <div className="img-box">
                                <HowToRegIcon/>
                            </div>
                            <h5 className="name">{t("condition")}</h5>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about_section layout_padding-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <div className="detail-box">
                                <h2>{t("aboutUs")}</h2>
                                <p>{t("TechCareDesc")}</p>
                                <Button onClick={() => navigate("/about")}>
                                    {t("readMore")}
                                </Button>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="img-box">
                                <img src={Images.Image3} alt="About Us"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="professional_section layout_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="img-box">
                                <img src={Images.Image5} alt="Professional Home Services"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="detail-box">
                                <h2>{t("aboutTechCare")}</h2>
                                <p>{t("aboutTechCareDesc")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="service_section layout_padding">
                <div className="container">
                    <div className="heading_container heading_center">
                        <h2>{t("ourServices")}</h2>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-4 mx-auto">
                            <div className="box">
                                <div className="img-box">
                                    <img src={Images.HospitalizationIcon} alt="Hospitalization"/>
                                </div>
                                <div className="detail-box">
                                    <h5>{t("hospitalizationInsurance")}</h5>
                                    <p>{t("hospitalizationInsuranceDesc")}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 mx-auto">
                            <div className="box">
                                <div className="img-box">
                                    <img src={Images.DeathIcon} alt="Plumbing"/>
                                </div>
                                <div className="detail-box">
                                    <h5>{t("deathInsurance")}</h5>
                                    <p>{t("deathInsuranceDesc")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn-box">
                        <Button onClick={() => handleToggleLoginModal("/claims")}>
                            {t("viewMore")}
                        </Button>
                    </div>
                </div>
            </section>
            <section className="client_section">
                <div className="container">
                    <div className="heading_container heading_center">
                        <h2>{t("whatClientsSay")}</h2>
                    </div>
                    <div
                        id="carouselExampleIndicators"
                        className="carousel slide"
                        data-ride="carousel"
                    >
                        <ol className="carousel-indicators">
                            <li
                                data-target="#carouselExampleIndicators0"
                                data-slide-to="0"
                                className="active"
                            ></li>
                            <li
                                data-target="#carouselExampleIndicators1"
                                data-slide-to="1"
                            ></li>
                            <li
                                data-target="#carouselExampleIndicators2"
                                data-slide-to="2"
                            ></li>
                        </ol>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="box">
                                            <div className="client_id">
                                                <div className="img-box">
                                                    <img
                                                        src={Images.ClientOne}
                                                        className="rounded-circle me-2 mb-2"
                                                        style={{
                                                            width: "45px",
                                                            height: "45px",
                                                            cursor: "pointer",
                                                            transform: "translateY(-12px) translateX(-5px)",
                                                        }}
                                                        alt="Fotso Sinclair"
                                                    />
                                                </div>
                                                <div className="client_detail">
                                                    <div className="client_info">
                                                        <h6>Fotso Sinclair</h6>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                    </div>
                                                    <i
                                                        className="fa fa-quote-left"
                                                        aria-hidden="true"
                                                    ></i>
                                                </div>
                                            </div>
                                            <div className="client_text">
                                                <p>
                                                    "This company provided excellent service and support
                                                    during my insurance claims process. The staff were
                                                    attentive and helped me through every step."
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-10">
                                        <div className="box">
                                            <div className="client_id">
                                                <div className="img-box">
                                                    <img
                                                        src={Images.Client2}
                                                        className="rounded-circle me-2 mb-2"
                                                        style={{
                                                            width: "45px",
                                                            height: "45px",
                                                            cursor: "pointer",
                                                            transform: "translateY(-12px) translateX(-5px)",
                                                        }}
                                                        alt="Adrian Nzeyang"
                                                    />
                                                </div>
                                                <div className="client_detail">
                                                    <div className="client_info">
                                                        <h6>Adrian Nzeyang</h6>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                    </div>
                                                    <i
                                                        className="fa fa-quote-left"
                                                        aria-hidden="true"
                                                    ></i>
                                                </div>
                                            </div>
                                            <div className="client_text">
                                                <p>
                                                    "I am extremely satisfied with the insurance policy I
                                                    got. It was affordable and comprehensive. The customer
                                                    service was outstanding."
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="box">
                                            <div className="client_id">
                                                <div className="img-box">
                                                    <img
                                                        src="images/client-1.jpg"
                                                        className="d-block w-100"
                                                        alt="John Smith"
                                                    />
                                                </div>
                                                <div className="client_detail">
                                                    <div className="client_info">
                                                        <h6>John Smith</h6>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                    </div>
                                                    <i
                                                        className="fa fa-quote-left"
                                                        aria-hidden="true"
                                                    ></i>
                                                </div>
                                            </div>
                                            <div className="client_text">
                                                <p>
                                                    "Their insurance coverage is second to none. I've been
                                                    a customer for years and have always been impressed by
                                                    their professionalism and efficiency."
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="box">
                                            <div className="client_id">
                                                <div className="img-box">
                                                    <img
                                                        src="images/client-2.jpg"
                                                        className="d-block w-100"
                                                        alt="Alice Brown"
                                                    />
                                                </div>
                                                <div className="client_detail">
                                                    <div className="client_info">
                                                        <h6>Alice Brown</h6>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                    </div>
                                                    <i
                                                        className="fa fa-quote-left"
                                                        aria-hidden="true"
                                                    ></i>
                                                </div>
                                            </div>
                                            <div className="client_text">
                                                <p>
                                                    "I highly recommend this insurance company. They offer
                                                    great policies and their support team is very
                                                    responsive and helpful."
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-controls">
                            <a
                                className="carousel-control-prev"
                                href="#carouselExampleIndicators"
                                role="button"
                                data-slide="prev"
                            >
                <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                                <span className="sr-only">{t("carouselPrev")}</span>
                            </a>
                            <a
                                className="carousel-control-next"
                                href="#carouselExample"
                                role="button"
                                data-slide="next"
                            >
                <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                                <span className="sr-only">{t("carouselNext")}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <Modal
                show={showModal}
                onHide={handleToggleLoginModal}
                centered
                size="lg"
                className="modal-responsive"
            >
                <Modal.Header className="modal-header-spaced">
                    <img
                        src={Images.digital}
                        style={{height: "100px", width: "100px"}}
                        alt="logo-image"
                    />
                    <Modal.Title>{t("titleConnect")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <Form className="row g-3">
                        <Col xs="12" sm="12" md="12" lg="6" xl="12">
                            <div className="mb-3">
                                <label
                                    htmlFor="userNameOrEmail"
                                    className="form-label fw-semibold"
                                >
                                    <i className="bi bi-person-circle me-2"></i>
                                    {t("insuranceID")}
                                </label>
                                <div className="phone-input position-relative">
                                    <input
                                        type="text"
                                        className={`form-control rounded-3 p-2 shadow-sm ${
                                            formError.userNameOrEmail ? "is-invalid" : ""
                                        }`}
                                        id="userNameOrEmail"
                                        placeholder={t("enterInsuranceID")}
                                        name="userNameOrEmail"
                                        value={formData.userNameOrEmail}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (!value.startsWith("237")) {
                                                value = "237" + value;
                                            }
                                            if (value.length < 4) {
                                                value = "237";
                                            }
                                            handleChange({
                                                target: {name: "userNameOrEmail", value},
                                            });
                                        }}
                                        required
                                    />
                                    {formError.userNameOrEmail && (
                                        <div className="invalid-feedback">
                                            {formError.userNameOrEmail}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col xs="12" sm="12" md="12" lg="6" xl="12">
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label fw-semibold">
                                    <i className="bi bi-lock me-2"></i> {t("techCarePIN")}
                                </label>
                                <div className="password-input-wrapper">
                                    <input
                                        type={viewpassword ? "text" : "password"}
                                        className={`form-control rounded-3 p-2 pe-5 ${
                                            formError.password ? "is-invalid" : ""
                                        }`}
                                        id="password"
                                        name="password"
                                        placeholder={t("enterPIN")}
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                    />
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            TogglePassword(e);
                                        }}
                                        className="password-toggle-btn"
                                        aria-label={
                                            viewpassword ? "Hide password" : "Show password"
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={viewpassword ? faEye : faEyeSlash}
                                            className="icon-size"
                                        />
                                    </button>
                                    {formError.password && (
                                        <div className="invalid-feedback">{formError.password}</div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Form>
                    {errorMessage && (
                        <div className="alert alert-danger rounded-3">{errorMessage}</div>
                    )}
                    {successMessage && (
                        <div className="alert alert-success rounded-3">
                            {successMessage}
                        </div>
                    )}
                    <div className="text-center mt-4">
                        <Button
                            className="btn w-100 mb-2 btn-primary rounded-3 p-2 shadow-sm"
                            onClick={handleLogin}
                        >
                            {loading ? <Spinner size="md" variant="light"/> : t("signIn")}
                        </Button>
                        <small className="d-block mb-2 text-muted">
                            {t("connexionDetail")}
                        </small>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={showOTPModal}
                onHide={() => setShowOTPModal(false)}
                centered
                size="lg"
                className="modal-responsive"
            >
                <Modal.Header className="modal-header-spaced">
                    <img
                        src={Images.digital}
                        style={{height: "100px", width: "100px"}}
                        alt="logo-image"
                    />
                    <Modal.Title>{t("VERIFY_OTP")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <Form className="row g-3">
                        <Col xs="12" sm="12" md="12" lg="12" xl="12">
                            <div className="mb-3">
                                <label htmlFor="otp" className="form-label fw-semibold">
                                    <i className="bi bi-key me-2"></i> {t("Code OTP")}
                                </label>
                                <input
                                    type="text"
                                    className={`form-control rounded-3 p-2 shadow-sm ${
                                        otpError ? "is-invalid" : ""
                                    }`}
                                    id="otp"
                                    placeholder={t("Entrer votre code OTP")}
                                    value={otp}
                                    onChange={handleOtpChange}
                                    required
                                />
                                {otpError && <div className="invalid-feedback">{otpError}</div>}
                            </div>
                        </Col>
                    </Form>
                    <div className="text-center mt-4">
                        <Button
                            className="btn w-100 mb-2 btn-primary rounded-3 p-2 shadow-sm"
                            onClick={handleOtpSubmit}
                        >
                            {loading ? <Spinner size="md" variant="light"/> : t("Vérifier")}
                        </Button>
                        <small className="d-block mb-2 text-muted">
                            {t("Entrer le code OTP envoyé par sms")}
                        </small>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Hme;